import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _regeneratorRuntime from "@babel/runtime/regenerator";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { getFormTemplates } from 'actions/templates';
import { translate } from '@haldor/ui';
import Modal from 'containers/Modals/Modal';
import FormTemplate from 'containers/Forms/FormTemplate';
import { Spinner } from 'UI';
import Card, { CardsContainer, CardTitle } from 'components/Cards/Card';
import { setPageTitle, setPageActions } from 'actions/header';

var AllForms = /*#__PURE__*/function (_Component) {
  _inherits(AllForms, _Component);

  var _super = _createSuper(AllForms);

  function AllForms(props) {
    var _this;

    _classCallCheck(this, AllForms);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "UNSAFE_componentWillMount", function () {
      var actions = [];

      _this.props.setPageTitle(_this.props.translate('form-templates'));

      actions.push({
        type: 'button',
        value: _this.props.translate('Create'),
        onClick: _this.toggleModal,
        icon: 'plus'
      });

      _this.props.setPageActions(actions);
    });

    _defineProperty(_assertThisInitialized(_this), "componentDidMount", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this.props.getFormTemplates();

            case 2:
              _this.setState({
                loading: false
              });

            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })));

    _defineProperty(_assertThisInitialized(_this), "toggleModal", function (reload) {
      _this.setState({
        modal: !_this.state.modal
      });

      if (reload) {
        _this.props.getFormTemplates();
      }
    });

    _this.state = {
      modal: false,
      loading: true
    };
    return _this;
  }

  _createClass(AllForms, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var translate = this.props.translate;
      return /*#__PURE__*/React.createElement("div", {
        className: "overview"
      }, /*#__PURE__*/React.createElement(Modal, {
        isOpen: this.state.modal,
        onClose: function onClose() {
          return _this2.toggleModal(false);
        },
        title: translate('create-template')
      }, /*#__PURE__*/React.createElement(FormTemplate, {
        onAbort: this.toggleModal
      })), this.state.loading ? /*#__PURE__*/React.createElement(Spinner, {
        center: true
      }) : null, this.props.templates != null && this.props.templates.length > 0 && !this.state.loading ? /*#__PURE__*/React.createElement("div", {
        className: "section",
        style: {
          margin: 0,
          padding: 0,
          border: 0
        }
      }, /*#__PURE__*/React.createElement(CardsContainer, null, this.props.templates.map(function (template) {
        return /*#__PURE__*/React.createElement(Card, {
          type: "group",
          key: template.id,
          id: template.id,
          target: "/forms/template/".concat(template.id)
        }, /*#__PURE__*/React.createElement(CardTitle, null, template.title));
      }))) : null);
    }
  }]);

  return AllForms;
}(Component);

function mapStateToProps(state) {
  return {
    services: state.Services.availableServices,
    translate: translate(state.Languages.translations),
    templates: state.Templates.templates
  };
}

;
export default connect(mapStateToProps, {
  setPageTitle: setPageTitle,
  setPageActions: setPageActions,
  getFormTemplates: getFormTemplates
})(AllForms);